import { Flex, HStack, Link, Text } from "@chakra-ui/react";
import * as React from "react";
import { Fragment } from "react";
import { LuChevronRight } from "react-icons/lu";
import { Link as RouterLink } from "react-router-dom";

import { useBreadcrumbsContext } from "./breadcrumbs";

export default function TopNav() {
  const { crumbs } = useBreadcrumbsContext();
  return (
    <Flex
      align="center"
      background="bg.page"
      borderBottomWidth="1"
      borderColor="border.soft"
      flexShrink="0"
      gap="6"
      height={"60px" as any}
      paddingX="6"
      position="sticky"
      top="0"
      zIndex="docked"
    >
      <HStack fontSize="sm" fontWeight="medium" gap="1.5" minWidth="0">
        {crumbs.map((crumb, index) => {
          const last = index === crumbs.length - 1;
          return (
            <Fragment key={index}>
              {last || crumb.to === undefined ? (
                <Text
                  color={last ? "fg.ink" : "fg.crumb"}
                  maxWidth={"230px" as any}
                  truncate
                >
                  {crumb.label}
                </Text>
              ) : (
                <Link
                  asChild
                  color="fg.crumb"
                  maxWidth={"230px" as any}
                  overflow="hidden"
                  textOverflow="ellipsis"
                  whiteSpace="nowrap"
                  display="inline-block"
                  _hover={{ color: "fg.muted", textDecoration: "none" }}
                >
                  <RouterLink to={crumb.to}>{crumb.label}</RouterLink>
                </Link>
              )}
              {!last && <LuChevronRight size="14" color="rgb(183,183,189)" />}
            </Fragment>
          );
        })}
      </HStack>
    </Flex>
  );
}
